/**
 * @desc Challenge window timeout length (currently set to 5 minutes but can be changed if necessary)
 */
const THREEDS_CHALLENGE_TIMEOUT = 300000;

/**
 * @desc Message to be displayed to the user in the event of an authentication failure.
 */
const UI_FAILURE_MSG = "3DS failed. Please try again or use a different credit card.";

/**
 * @desc Enumerates known reasons that the challenge promise would be rejected
 */
const REJECT_REASONS = {
    CHALLENGE_TIMEOUT: Symbol(),
    CLOSED_BY_USER: Symbol()
}

/**
 * @desc Indicates if a supplied value is one of the well known REJECT_REASONS
 *
 * @param {any} r
 */
function IsARejectReason(r) {
    try {
        return Object.values(REJECT_REASONS).some(r);    
    } catch (r) {
        return false;
    } 
}

/**
 * @desc Random identified for challenge window.
 */
const randomId = Math.random().toString(16).substr(2, 8);

/**
 * @desc Action to be called on error.
 */
let onErrorAction;

/**
 * @desc Window timeout.
 */
let timeout;

/**
 * @desc Challenge status indicator.
 */
let statusIndicator;

/**
 * @desc Remove the challenge modal and clear the associated timeout.
 *
 * @param {any} timeoutId
 */
function ensureChallengeWindowClosed(timeoutId) {
    if (timeoutId) {
        clearTimeout(timeoutId);
    } else {
        clearTimeout(timeout);
    }
    try {
        Array.prototype.slice.call(document
            .querySelectorAll("[target$=\"-" + randomId + "\"],[id$=\"-" + randomId + "\"]"))
            .forEach(function (element) {
                if (element.parentNode) {
                    element.parentNode.removeChild(element);
                }
            });
    }
    catch (e) {
        /** nom, nom, nom */
    }
}

/**
 * @desc Creates and displays the 3D Secure challenge window.
 *
 * @param {any} endpoint
 * @param {any} fields
 * @param {any} options
 */
function postToIframe(endpoint, fields, options) {
    return new Promise(function (resolve, reject) {
        timeout = setTimeout(function () {
            ensureChallengeWindowClosed(timeout);
            console.log("challenge window has timed out");
            reject(REJECT_REASONS.CHALLENGE_TIMEOUT);
        }, THREEDS_CHALLENGE_TIMEOUT);

        var iframe = document.createElement("iframe");
        iframe.id = iframe.name = "PayCentral-3DSecure-ChallengeWindow-" + randomId;
        iframe.style.display = "inherit";

        var form = createForm(endpoint, iframe.id, fields);
        createModal(iframe, options, reject);

        window.addEventListener("message", handleMessageEvent(resolve, {
            origin: options.origin,
            timeout: timeout,
        }));

        document.body.appendChild(form);
        form.submit();
    });
}

/**
 * @desc Handles the iframe on load event.
 *
 * @param {any} iFrame
 * @param {any} spinner
 * @param {any} overlayElement
 * @param {any} options
 * @param {function} reject - reject delegate from the challenge promise 
 */
function handleIFrameOnloadEvent(iFrame, spinner, overlayElement, options, reject) {
    return function () {
        iFrame.style.opacity = "1";
        iFrame.style.transform = "scale(1)";
        iFrame.style.backgroundColor = "#ffffff";
        if (spinner.parentNode) {
            spinner.parentNode.removeChild(spinner);
        }
        var closeButton = createCloseButton(options);
        if (closeButton) {
            overlayElement.appendChild(closeButton);
            closeButton.addEventListener("click", function () {
                console.log("click");
                if (closeButton) {
                    closeModal(reject);
                }
            }, true);
        }
    };
}

/**
 * @desc Create and style the modal window.
 *
 * @param {any} iFrame
 * @param {any} options
 * @param {function} reject - reject delegate from the challenge promise 
 */
function createModal(iFrame, options, reject) {
    var spinner = createSpinner();
    document.body.appendChild(spinner);

    iFrame.setAttribute("height", "500px");
    iFrame.setAttribute("frameBorder", "0");
    iFrame.setAttribute("width", "600px");

    iFrame.setAttribute("seamless", "seamless");
    iFrame.style.zIndex = "10001";
    iFrame.style.position = "absolute";
    iFrame.style.transition = "transform 0.5s ease-in-out";
    iFrame.style.transform = "scale(0.7)";
    iFrame.style.opacity = "0";

    var overlayElement = createOverlay();
    overlayElement.appendChild(iFrame);
    var width = 600;
    iFrame.style.top = "40px";
    iFrame.style.left = "50%";
    iFrame.style.marginLeft = "-" + width / 2 + "px";
    iFrame.onload = handleIFrameOnloadEvent(iFrame, spinner, overlayElement, options, reject);
}

/**
 * @desc Create our form using the requested action, fields, and target element.
 *
 * @param {any} action
 * @param {any} target
 * @param {any} fields
 */
function createForm(action, target, fields) {
    var form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", action);
    form.setAttribute("target", target);
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var field = fields_1[_i];
        var input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", field.name);
        input.setAttribute("value", field.value);
        form.appendChild(input);
    }
    return form;
}

/**
 * @desc Create the window overlay.
 */
function createOverlay() {
    var overlay = document.createElement("div");
    overlay.setAttribute("id", "PayCentral-overlay-" + randomId);
    overlay.style.position = "fixed";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.transition = "all 0.3s ease-in-out";
    overlay.style.zIndex = "100";
    document.body.appendChild(overlay);
    setTimeout(function () {
        overlay.style.background = "rgba(0, 0, 0, 0.7)";
    }, 1);
    return overlay;
}

/**
 * @desc Create the loading/action spinner.
 */
function createSpinner() {
    var spinner = document.createElement("img");
    spinner.setAttribute("src",
        "data:image/svg+xml;base64,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");
    spinner.setAttribute("id", "PayCentral-loader-" + randomId);
    spinner.style.left = "50%";
    spinner.style.position = "fixed";
    spinner.style.background = "#FFFFFF";
    spinner.style.borderRadius = "50%";
    spinner.style.width = "30px";
    spinner.style.zIndex = "200";
    spinner.style.marginLeft = "-15px";
    spinner.style.top = "120px";
    return spinner;
}

/**
 * @desc Create the modal window close button.
 *
 * @param {any} options
 */
function createCloseButton() {
    if (document.getElementById("PayCentral-frame-close-" + randomId) !== null) {
        return null;
    }
    var closeButton = document.createElement("img");
    closeButton.id = "PayCentral-frame-close-" + randomId;
    closeButton.src =
        "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUJFRjU1MEIzMUQ3MTFFNThGQjNERjg2NEZCRjFDOTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUJFRjU1MEMzMUQ3MTFFNThGQjNERjg2NEZCRjFDOTUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBQkVGNTUwOTMxRDcxMUU1OEZCM0RGODY0RkJGMUM5NSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBQkVGNTUwQTMxRDcxMUU1OEZCM0RGODY0RkJGMUM5NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlHco5QAAAHpSURBVHjafFRdTsJAEF42JaTKn4glGIg++qgX4AAchHAJkiZcwnAQD8AF4NFHCaC2VgWkIQQsfl/jNJUik8Duzs/XmW9mN7Xb7VRc5vP5zWKxaK5Wq8Zmu72FqobfJG0YQ9M0+/l8/qFQKDzGY1JxENd1288vLy1s786KRZXJZCLber1Wn7MZt4PLarVnWdZ9AmQ8Hncc17UvymVdBMB/MgPQm+cFFcuy6/V6lzqDf57ntWGwYdBIVx0TfkBD6I9M35iRJgfIoAVjBLDZbA4CiJ5+9AdQi/EahibqDTkQx6fRSIHcPwA8Uy9A9Gcc47Xv+w2wzhRDYzqdVihLIbsIiCvP1NNOoX/29FQx3vgOgtt4FyRdCgPRarX4+goB9vkyAMh443cOEsIAAcjncuoI4TXWMAmCIGFhCQLAdZ8jym/cRJ+Y5nC5XCYAhINKpZLgSISZgoqh5iiLQrojAFICVwGS7tCfe5DbZzkP56XS4NVxwvTI/vXVVYIDnqmnnX70ZxzjNS8THHooK5hMpxHQIREA+tEfA9djfHR3MHkdx3Hspe9r3B+VzWaj2RESyR2mlCUE4MoGQDdxiwHURq2t94+PO9bMIYyTyDNLwMoM7g8+BfKeYGniyw2MdfSehF3Qmk1IvCc/AgwAaS86Etp38bUAAAAASUVORK5CYII=";
    closeButton.style.transition = "all 0.5s ease-in-out";
    closeButton.style.opacity = "0";
    closeButton.style.float = "left";
    closeButton.style.position = "absolute";
    closeButton.style.left = "50%";
    closeButton.style.zIndex = "99999999";
    closeButton.style.top = "30px";
    var width = 600;
    closeButton.style.marginLeft = width / 2 - 8 + "px";
    
    setTimeout(function () {
        closeButton.style.opacity = "1";
    }, 500);
    return closeButton;
}

/**
 * @desc Handles the modal window close event.
 *
 * @param {function} reject - reject delegate from the challenge promise 
 */
function closeModal(reject) {
    ensureChallengeWindowClosed();
    console.log("user closed the challenge window");
    reject(REJECT_REASONS.CLOSED_BY_USER);
}

/**
 * @desc Add notification window message listeners.
 *
 * @param {any} resolve
 * @param {any} data
 */
function handleMessageEvent(resolve, data) {
    return function (e) {
        console.log(e.data);
        const eventData = e.data;
        // If the message doesn't contain the properties we are looking for then discard it.
        if (!eventData.hasOwnProperty("data") || !eventData.data.hasOwnProperty("statusIndicator")) return;
        // Store the status indicator, clear the timeout, then resolve the promise.
        statusIndicator = eventData.data.statusIndicator;
        ensureChallengeWindowClosed(data.timeout || timeout);
        resolve(e.data);
    };
}

/**
 * Handle challenge window.
 *
 * @desc Handles response from merchant integration endpoint for initiating 3DS 2.0 authentication flows with consumer.
 *       If a challenge is mandated, an iframe will be created for the issuer's necessary challenge URL.
 *
 * @param {any} challenge - the 3DS challenge data from pay central
 * @param {any} onSuccess - call on success
 * @param {any} onError - called for errors and failures
 */
async function display3dsChallenge(challenge, onSuccess, onError) {

    try {
        let data = challenge.data;
        onErrorAction = onError;
        let result = await postToIframe(data.challengeUrl, [{ name: "creq", value: data.challengePayload }], {});
        console.log("challenge complete.", statusIndicator, result);
        if (statusIndicator === "Y") {
            onSuccess(challenge.id);
        } else {
            onError(UI_FAILURE_MSG);
        }
    } catch (e) {
        // will end up here for any of the known reasons in REJECT_REASONS
        if (!IsARejectReason(e)) console.warn(e);
        onError(UI_FAILURE_MSG);
    }
};

export default display3dsChallenge;